export default __webpack_public_path__ + "static/media/twelve.bc0e05d8.jpg";